import { ActivatedRoute } from '@angular/router';
import { SettingsService } from '../../state/settings/settings.service';
import { UserService } from '../../state/user/user.service';
import { CompanyService } from '../../state/company/company.service';
import { ClinicDetailService } from '../../state/clinic-detail/clinic-detail.service';
import { NavController } from '@ionic/angular';
import { ClinicDetailQuery } from '../../state/clinic-detail/clinic-detail.query';
import { SettingsQuery } from '../../state/settings/settings.query';
import { UserQuery } from '../../state/user/user.query';
import { Observable } from 'rxjs';
import { UserState } from '../../state/user/user.store';
import { ClinicDetailState } from '../../state/clinic-detail/clinic-detail.store';
import { MessageDetailService } from '../../state/message-detail/message-detail.service';
import { MessageDetailQuery } from '../../state/message-detail/message-detail.query';
import { MessageDetailState } from '../../state/message-detail/message-detail.store';
import { RouterService } from '../../../core/services/router/router.service';

export class MessageInitializaterComponent {
    params$;
    queryParams$;
    clinic$: Observable<ClinicDetailState>;
    user$: Observable<UserState>;
    message$: Observable<MessageDetailState>;
    message: MessageDetailState;
    systemKeyParam;
    clinicIdParam;
    messageIdParam;
    messageSuscription$;
    isLoadingContent = false;
    partentSystemKeyQueryParam;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected settingsService: SettingsService,
        protected userService: UserService,
        protected companyService: CompanyService,
        protected clinicDetailService: ClinicDetailService,
        protected navCtrl: NavController,
        protected clinicDetailQuery: ClinicDetailQuery,
        protected settingsQuery: SettingsQuery,
        protected userQuery: UserQuery,
        protected messageDetailQuery: MessageDetailQuery,
        protected messageDetailService: MessageDetailService,
        protected routerService: RouterService
    ) {}

    /** Inicializar la Company, Clinic y User */
    protected async initializeCompanyClinicUserMessage() {
        /** Obtenemos los parámetros de entrada */
        this.params$ = this.activatedRoute.params.subscribe((params) => {
            this.systemKeyParam = params.systemKey;
            this.settingsService.updateSystemKeyURL(params.systemKey);
            this.clinicIdParam = params.clinicId;

            /** Parámetro de messageId */
            if (params.messageId) {
                this.messageIdParam = params.messageId;
            }
        });

        this.queryParams$ = this.activatedRoute.queryParams.subscribe(
            (params) => {
                if (params.parentSystemKey) {
                    this.partentSystemKeyQueryParam = params.parentSystemKey;
                    this.settingsService.updateSystemKey(
                        this.partentSystemKeyQueryParam
                    );
                }
                if (params.tokenId) {
                    this.userService.updateTokenIdAux(params.tokenId);
                }
            }
        );

        this.clinic$ = this.clinicDetailQuery.select();
        this.user$ = this.userQuery.select();
        this.message$ = this.messageDetailQuery.select();
        this.messageSuscription$ = this.messageDetailQuery
            .select()
            .subscribe((data) => {
                this.message = data;
            });

        try {
            /** Comprobamos si tenemos la company cargada para cargarla */
            await this.companyService.checkCompanyAndInit(
                this.partentSystemKeyQueryParam !== ''
                    ? this.partentSystemKeyQueryParam
                    : null
            );
            await this.clinicDetailService.checkClinicAndInit(
                this.systemKeyParam,
                this.clinicIdParam
            );
        } catch (e) {
            this.navCtrl.navigateRoot('/');
        }

        try {
            await this.userService.checkUserAndLoad(false, true);

            if (this.messageIdParam && this.messageIdParam !== '') {
                await this.messageDetailService.getMessage(this.messageIdParam);
            }
        } catch (e) {
            this.routerService.goToMainTabWithoutLogin();
        }
    }

    /** Desuscribirse de los parámetros de ruta y query Params */
    protected unsuscribeParamsQueryParams() {
        this.params$.unsubscribe();
        this.queryParams$.unsubscribe();
        this.messageSuscription$.unsubscribe();
    }
}
